export default __webpack_public_path__ + "static/media/image_placeholder.d6c74ba3.jpg";